import {
  RebateTakeoutOptions,
  RebateTakeoutOptionsEnum,
} from '@usf/product-types';

/**
 * Returns the RebateTakeoutOptionsEnum value based on the provided takeout option number
 * @param takeoutOption - The takeout option number to match
 * @returns The corresponding RebateTakeoutOptionsEnum value or undefined if no match is found
 */
export function getRebateTakeoutOptionEnum(
  takeoutOption: number,
): RebateTakeoutOptionsEnum | undefined {
  if (RebateTakeoutOptions.GetToKnowUs.includes(takeoutOption)) {
    return RebateTakeoutOptionsEnum.GetToKnowUs;
  }

  if (RebateTakeoutOptions.PartnerWithUs.includes(takeoutOption)) {
    return RebateTakeoutOptionsEnum.PartnerWithUs;
  }

  // if (RebateTakeoutOptions.GrowWithUs.includes(takeoutOption)) {
  //   return RebateTakeoutOptionsEnum.GrowWithUs;
  // } TODO: Enable when grow with us page is built

  return undefined;
}
